/**
 * The declaration of one `PropertyListHelper` family (`item_<N>/<leaf>`): the engine facts the
 * validator, the past-count rule and the parser grouping all derive from, stated once per class.
 * The leaves are the keys of the validator table, which is their one list.
 */
/**
 * Identity at runtime. The `const` parameter keeps each literal (`'dropped'`, a null key), so derivations narrow on the declaration and a field left out does not compile.
 */
export function defineIndexedFamily(family) {
    return family;
}
//# sourceMappingURL=indexedFamily.js.map